/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import { Autocomplete } from '@totalsoft/rocket-ui';

export const AutocompleteFilterCell = ({ filter, onFilter, autocompleteOptions, id, value }) => {
  return (
    <TableCell>
      <Autocomplete
        fullWidth
        valueKey={id}
        labelKey={value}
        value={filter ? filter.value : ''}
        id='active'
        simpleValue
        options={autocompleteOptions}
        onChange={e => onFilter(e ? { value: e } : null)}
        isClearable
      />
    </TableCell>
  );
};

AutocompleteFilterCell.propTypes = {
  filter: PropTypes.object,
  onFilter: PropTypes.func.isRequired,
  autocompleteOptions: PropTypes.array.isRequired,
  id: PropTypes.string,
  value: PropTypes.any
};

export default AutocompleteFilterCell;
